export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '87b3ddff-d8fe-4275-b1c2-1fa5fc877c32';
export const MODAL_CLOSE_SEC = 2.5;
